import { formatNotional, formatVal, fullUSD, isCommodityTrade } from './formatters';

const present = (value) => value != null && value !== '';

const optionalField = (label, value, formatter) => ({
  label,
  value: present(value) ? (formatter ? formatter(value) : String(value)) : null,
});

export function getTradeDetailSections(t, v, selectedDate) {
  return [
    {
      title: 'Main Details',
      showMissing: true,
      fields: [
        optionalField('Trade ID', t.trade_id),
        optionalField('Trade Type', t.trade_type),
        optionalField('Trade Date', t.trade_date),
        optionalField('Effective Date', t.effective_date),
        optionalField('Termination Date', t.termination_date),
      ],
    },
    {
      title: 'Leg 1',
      fields: [
        optionalField('Party', t.leg1_party),
        optionalField('Pay', t.leg1_pay),
        optionalField('Index', t.leg1_index),
        optionalField(isCommodityTrade(t.trade_type) ? 'Price' : 'Rate', t.leg1_rate, formatVal),
        optionalField('Strike', t.leg1_strike, formatVal),
        optionalField('Spread', t.leg1_spread, formatVal),
        optionalField('Leverage', t.leg1_leverage, formatVal),
        optionalField('Day Count', t.leg1_daycount),
        optionalField('Pay Freq', t.leg1_payfreq),
        optionalField('Pay Date', t.leg1_paydate),
      ],
    },
    {
      title: 'Leg 2',
      fields: [
        optionalField('Party', t.leg2_party),
        optionalField('Pay', t.leg2_pay),
        optionalField('Index', t.leg2_index),
        optionalField('Rate', t.leg2_rate, formatVal),
        optionalField('Strike', t.leg2_strike, formatVal),
        optionalField('Spread', t.leg2_spread, formatVal),
        optionalField('Leverage', t.leg2_leverage, formatVal),
        optionalField('Day Count', t.leg2_daycount),
        optionalField('Pay Freq', t.leg2_payfreq),
        optionalField('Pay Date', t.leg2_paydate),
      ],
    },
    {
      title: `Valuation & Metrics (as of ${selectedDate || '—'})`,
      showMissing: true,
      columns: 5,
      fields: [
        optionalField('Clean', v?.clean_value, (value) => fullUSD(Number(value))),
        optionalField('Accrued', v?.accrued, (value) => fullUSD(Number(value))),
        optionalField('Total', v?.total_value, (value) => fullUSD(Number(value))),
        optionalField('Notional', v?.notional_amount, (value) =>
          formatNotional(Number(value), t.trade_type),
        ),
        optionalField('PV01', v?.pv01, (value) => fullUSD(Number(value))),
      ],
    },
  ];
}
